import moment from 'moment'
import { ADD_DISCOUNT_MODEL, GET_USER_DISCOUNT } from './actions'

const initial = {
  discountModel: {},
  userDiscounts: [],
  howManyUserDiscounts: {},
}

export default function discountReducer(state = initial, action) {
  switch (action.type) {
    case ADD_DISCOUNT_MODEL:
      return {
        ...state,
        discountModel: action.payload,
      }
    case GET_USER_DISCOUNT:
      let sortData = {}
      action.payload.map(discount => {
        const date = [moment(discount.updatedAt).format('DD/MM')]
        if (sortData[date]) {
          return (sortData = { ...sortData, [date]: [...sortData[date], discount?.lastDiscount] })
        } else {
          return (sortData = { ...sortData, [date]: [discount?.lastDiscount] })
        }
      })

      let HowManyUserGetDiscount = {}
      action.payload.map(discounts => {
        const date = [moment(discounts.updatedAt).format('DD/MM')]
        if (HowManyUserGetDiscount[date]) {
          return (HowManyUserGetDiscount = {
            ...HowManyUserGetDiscount,
            [date]: HowManyUserGetDiscount[date] + 1,
          })
        } else {
          return (HowManyUserGetDiscount = { ...HowManyUserGetDiscount, [date]: 1 })
        }
      })
      return {
        ...state,
        userDiscounts: sortData,
        howManyUserDiscounts: HowManyUserGetDiscount,
      }
    default:
      return state
  }
}
